module.exports = __webpack_public_path__ + "assets/logo.cadecce9.svg";